import React, { FC, useState } from 'react'
import { IFilterAutocompleteProp, ISuggestResult } from 'transfix-ui/components/FilterAutocomplete'
import { Box } from 'transfix-ui/core'
import { StaplesHeadhaulLanesFilters } from 'apps/marketplace/apiTypes/staplesHeadhaulLanes'
import CarrierFilterAutocomplete from 'apps/marketplace/components/CarrierFilterAutocomplete'
import LaneLocationSearch, {
  ILaneLocationSearchValues,
} from 'apps/marketplace/pages/lane/assignment/LaneLocationSearch'

interface IStaplesHeadhaulLanesFiltersProps {
  filters?: StaplesHeadhaulLanesFilters
  onSetFilters: (filters: Partial<StaplesHeadhaulLanesFilters>) => void
}

const StaplesHeadhaulLanesFilter: FC<IStaplesHeadhaulLanesFiltersProps> = ({
  filters,
  onSetFilters,
}) => {
  const [toggleClear] = useState<boolean>(false)

  const isAutosuggestResult = (autocompleteObj: any): autocompleteObj is ISuggestResult => {
    return autocompleteObj && !Array.isArray(autocompleteObj) && typeof autocompleteObj === 'object'
  }

  const autocompleteFilters = (autocompleteObj: IFilterAutocompleteProp, key: string) => {
    if (isAutosuggestResult(autocompleteObj)) {
      onSetFilters({ ...filters, [key]: autocompleteObj.id })
    } else {
      onSetFilters({ [key]: undefined })
    }
  }

  const onCarrierChange = (val: IFilterAutocompleteProp) => {
    autocompleteFilters(val, 'carrierApplicationId')
  }

  const onLocationChange = (field: string, value?: ILaneLocationSearchValues) => {
    onSetFilters({ [field]: value?.city })
  }

  return (
    <>
      <Box display='flex' flexGrow={1} width='33%' alignItems='flex-end' className='flex-auto-l'>
        <Box display='flex' mr={2}>
          <LaneLocationSearch
            placeholder='Search Pickup City'
            id='pickupCity'
            dataTest='search-pickup'
            onChange={onLocationChange}
            hasValue
          />
        </Box>
        <Box flexGrow={1} width='33%' alignItems='flex-end' className='flex-auto-l' mr={2}>
          <LaneLocationSearch
            placeholder='Search Delivery City'
            id='deliveryCity'
            dataTest='search-delivery'
            onChange={onLocationChange}
            hasValue
          />
        </Box>
        <Box width='auto' ml={1}>
          <CarrierFilterAutocomplete
            label='Carrier'
            onSelectedValue={onCarrierChange}
            toggleClear={toggleClear}
          />
        </Box>
      </Box>
    </>
  )
}

export default StaplesHeadhaulLanesFilter
